import { useMemo } from 'react'
import { SceneCrossSections, type SceneCrossSectionElement } from '@scene'
import { ImmutableVector3 } from '@modugen/ui-toolkit'
import { useSceneElement } from '@editorHooks'
import {
  buildCoordinateSystemForRipSegment,
  DEFAULT_RIP_CROSS_SECTION_SIZE,
  DEFAULT_RIP_PREVIEW_CROSS_SECTION,
  isValidRipLine,
  RipLine,
} from './utils'

const RIP_SCENE_MARKER_COLOR = 'blue'

interface Props {
  lines?: RipLine[]
  ripStart?: ImmutableVector3
  ripEnd?: ImmutableVector3
}

const RipLineSceneMarker = ({ lines: externalLines, ripStart, ripEnd }: Props): null => {
  const sceneElements = useMemo((): SceneCrossSectionElement[] => {
    let ripLines: RipLine[] = []
    if (externalLines) {
      ripLines = externalLines.filter(isValidRipLine)
    } else if (ripStart && ripEnd && isValidRipLine([ripStart, ripEnd])) {
      ripLines = [[ripStart, ripEnd]]
    }

    return ripLines.map(([start, end], index) => ({
      id: `rip-scene-marker-${index}`,
      start,
      end,
      coordinateSystem: buildCoordinateSystemForRipSegment(start, end),
      height: DEFAULT_RIP_CROSS_SECTION_SIZE,
      width: DEFAULT_RIP_CROSS_SECTION_SIZE,
      crossSection: DEFAULT_RIP_PREVIEW_CROSS_SECTION,
      elementType: 'rips',
      color: RIP_SCENE_MARKER_COLOR,
    }))
  }, [externalLines, ripStart, ripEnd])

  const sceneElement = useMemo(
    () => ({
      enabled: sceneElements.length > 0,
      properties: { elements: sceneElements },
      component: SceneCrossSections,
    }),
    [sceneElements],
  )

  useSceneElement(sceneElement)

  return null
}

export default RipLineSceneMarker
